// generic user interface related action
import { createAction } from 'redux-act';

export const toggleFeatureFlag = createAction('FEATURE_FLAG/TOGGLE');

export const resetFeatureFlags = createAction('FEATURE_FLAG/RESET');
